import { useEffect, useState } from "react";

/** Keep mounted through exit so opacity/transform animations can finish. */
export function usePresence(open: boolean, exitMs = 200) {
    const [mounted, setMounted] = useState(open);
    const [visible, setVisible] = useState(open);

    useEffect(() => {
        if (open) {
            setMounted(true);
            const id = requestAnimationFrame(() => {
                requestAnimationFrame(() => setVisible(true));
            });
            return () => cancelAnimationFrame(id);
        }
        setVisible(false);
        const t = window.setTimeout(() => setMounted(false), exitMs);
        return () => window.clearTimeout(t);
    }, [open, exitMs]);

    return { mounted, visible };
}
